import { defaultSite, defaultFilterSites } from "./state";

/**
 * Mutación que pone por defecto la locación.
 *
 * @param {*} state.site - El estado la locación.
 * @returns {void}
 * @author Brandon Torres
 */
export function setSiteDefault(state) {
    state.site = defaultSite();
}

/**
 * Mutación que establece las locaciones.
 *
 * @param {*} state.sites - El estado de las locaciones.
 * @param {*} sites - Las locaciones.
 * @returns {void}
 * @autor Brandon Torres
 */
export function setSites(state, sites) {
    state.sites = sites;
}

/**
 * Mutación que establece el paginador de registros de locaciones.
 *
 * @param paginate - Paginación de registros.
 * @param {*} state.filterSites.page - Página actual.
 * @param {*} state.filterSites.per_page - Cantidad de registros por página.
 * @param {*} state.filterSites.total - Total de registros.
 * @return {void}
 * @author Brandon Torres
 */
export function setPaginateSites(state, paginate) {
    state.filterSites = {
        ...state.filterSites,
        page: paginate.current_page,
        per_page: paginate.per_page,
        total: paginate.total,
    };
}

/**
 * Mutación que establece la cantidad de locaciones por página.
 *
 * @param {*} state.filterSites.per_page - Cantidad de registros por página.
 * @param {*} state.filterSites.page - Página actual.
 * @param per_page - Cambio de cantidad de registros por página.
 * @return {void}
 * @author Brandon Torres
 */
export function loadAfterChangeSizePagination(state, per_page) {
    state.filterSites = {
        ...state.filterSites,
        page: 1,
        per_page: per_page,
    };
}

/**
 * Mutación que establece la página actual.
 *
 * @param page - Cambio de página actual.
 * @param {*} state.filterSites.page - Página actual.
 * @return {void}
 * @author Brandon Torres
 */
export function loadAfterChangePagePagination(state, page) {
    state.filterSites.page = page;
}

/**
 * Mutación que establece el filtro de locaciones por defecto.
 *
 * @param {*} state.filterSites - Estado del filtro de locaciones.
 * @return {void}
 * @author Brandon Torres
 */
export function setDefaultFilterSites(state) {
    state.filterSites = defaultFilterSites();
}

/**
 * Mutación que establece la locación.
 *
 * @param {*} state.site - Estado de la locación.
 * @param site - Locación.
 * @return {void}
 * @author Brandon Torres
 */
export function setSite(state, site) {
    state.site = site;
}

/**
 * Mutación que establece las locaciones activas.
 *
 * @param {*} state.sitesActive - Estado de las locaciones activas.
 * @param sites - Locaciones activas.
 * @return {void}
 * @autor Brandon Torres
 */
export function setSitesActive(state, sites) {
    state.sitesActive = sites;
}
